<script lang="ts">
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import {getInjector, getLocalization, getSanitize} from 'core/svelte-context/context';
    import ExemplarPlacementPresenter from './exemplar-placement.presenter';
    import type {Exemplar} from 'typings/portaro.be.types';
    import type {Regal} from 'typings/portaro.be.types';
    import {fade} from 'svelte/transition';

    export let exemplar: Exemplar;

    const localize = getLocalization();
    const presenter = getInjector().getByClass(ExemplarPlacementPresenter);
    const sanitizeHtml = getSanitize();

    const loadPlacement = async (): Promise<Regal | undefined> => {
        return presenter.loadPlacement(exemplar);
    };
</script>

<tr in:fade={{duration: 250}}>
    <td class="text-center" colspan="100">
        {#await loadPlacement()}
            <KpLoadingBlock size="xs"/>
        {:then placement}
            {#if placement}
                <div class="panel-body">
                    {#if placement.withMap}
                        <div class="map-image-container">
                            <img class="map-image"
                                 src="data:image/jpeg;base64,{placement.map}"
                                 width={placement.dimensions.width}
                                 height={placement.dimensions.height}
                                 alt={localize(/* @kp-localization exemplar.placement */ 'exemplar.placement')}/>
                        </div>
                    {/if}
                    <div class="map-info">{@html sanitizeHtml(pipe(placement.information, loc()))}</div>
                </div>
            {:else}
                {localize(/* @kp-localization exemplar.DataOUmisteniExNejsouKDispozici */ 'exemplar.DataOUmisteniExNejsouKDispozici')}
            {/if}
        {/await}
    </td>
</tr>